<h2 class="mat-dialog-title">Candidatos da seleção</h2>

<mat-dialog-content cdkDropListGroup>
    
    <ng-template #interviewStep>

        <mat-action-list>
            <button mat-list-item *ngFor="let item of interviews" (click)="selectedInterview = item"
                (click)="selectInterview(item)"
                [ngClass]="{ activated: item.id === selectedInterview?.id }">
                
                <h3 matLine>{{ item.name }}</h3>                    
                <p matLine>
                    {{ item.date_start | date: 'dd/MM/yyyy' }} às {{ formatTime(item.time_start) }}
                    <ng-container *ngIf="item.time_end">
                        até {{formatTime(item.time_end)}}
                    </ng-container>
                    <ng-container *ngIf="item.type">
                        <span matLine>Tipo: {{item.type === 'true' ? 'Entrevista Remota' : 'Entrevista Presencial'}}</span>
                    </ng-container>
                </p>
                <p matLine *ngIf="item.type === 'false'">{{ item.address }}</p>
                <span matLine>Falar com {{ item.contact }}</span>
                <button mat-icon-button color="primary" >
                    <mat-icon>arrow_forward</mat-icon>
                </button>
            </button>
        </mat-action-list>

        <div class="empty-content" *ngIf="interviews?.length === 0">

            <span class="mat-body-2">
                Nenhuma entrevista encontrada!
            </span>

        </div>

    </ng-template>

    <ng-template #sessionStep>

        <ng-template #interviewContent>
            <div class="col">
                <span class="mat-title">Candidatos</span>

                <div class="controls">
                    <button mat-stroked-button [color]="areAllCandidatesSelected ? 'warn' : 'primary'" (click)="toggleSelectCandidates()" >{{ areAllCandidatesSelected ? 'Deselecionar todos candidatos' : 'Selecionar todos candidatos' }}</button>
                    <button mat-raised-button color="primary" [disabled]="!hasSelection()" (click)="addCandidateInSession()">
                        Agendar
                        <mat-icon>arrow_forward_ios</mat-icon>
                    </button> 
                </div>

                <mat-selection-list #candidatesList cdkDropList [cdkDropListData]="candidates" (cdkDropListDropped)="onCandidateDropped($event)">
                    <ng-container *ngFor="let candidate of candidates">
                        <mat-list-option [value]="candidate" cdkDrag [cdkDragData]="candidate" [disabled]="candidate.candidateStatus !== 'pending'" 
                            [disabled]="hasCandidateSelected(candidate)">
                            <h3 matLine>{{ candidate.firstname }} {{ candidate.lastname }}</h3>
                            <p matLine>{{ candidate.city }}</p>
                            <span matLine *ngIf="candidate.candidateStatus === 'hired'" style="color: #093">Já contratado</span>
                            
                            <!-- Template para a visualização durante o arraste -->
                            <ng-template cdkDragPreview>
                                <div class="drag-preview">
                                    <mat-list>
                                      <mat-list-item>
                                        <img [src]="mediaEndpoint + candidate.avatar_profile" matListAvatar *ngIf="candidate?.avatar_profile"/>
                                        <mat-icon  matListIcon *ngIf="candidate && candidate.avatar_profile == null">
                                          account_circle
                                        </mat-icon>    
                                  
                                        <!-- Nome e cidade alinhados verticalmente -->
                                        <div class="drag-text">
                                          <p class="name">{{ candidate.firstname }} {{ candidate.lastname }}</p>
                                          <p class="city">{{ candidate.city }}</p>
                                          <span *ngIf="candidate.candidateStatus === 'hired'" class="hired">
                                            Já contratado
                                          </span>
                                        </div>
                                      </mat-list-item>
                                    </mat-list>
                                </div>                                  
                            </ng-template>
                            
                        </mat-list-option>
                    </ng-container>
                </mat-selection-list>

            </div>
        </ng-template>

        <ng-template #sessionContent>
            <div class="col sessions">
                <span class="mat-title">Horários dos candidatos</span>

                <div class="controls">

                    <div style="margin-bottom: 10px;">
                        <mat-chip-list aria-label="Fish selection">
                            <ng-container *ngFor="let day of excludeDays; let i = index">
                                <mat-chip color="primary" selected
                                    [removable]="true"
                                    (removed)="removeExcludeDay(i)">
                                    <small>{{ day | date: 'dd/MM' }}</small>
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>

                    <ng-container *ngIf="selectedInterview?.next_days">
                        <form [formGroup]="formExcludeDays">
                            <div class="row">
                                <mat-form-field appearance="outline">
                                    <mat-label>Dias de exceções da entrevista</mat-label>
                                    <input matInput type="date" [min]="selectedInterview.date_start" formControlName="days" (blur)="onSubmit()" (keydown.enter)="onSubmit()" />
                                </mat-form-field>
                            </div>                                
                        </form>
                    </ng-container>

                </div>

                <mat-list>
                    
                    <ng-container *ngFor="let session of sessions; let i = index">

                        <ng-container *ngIf="!isSameDate(i)">
                            <span matSubheader>Dia {{ session.date | date: 'dd/MM' }}</span>
                        </ng-container>

                        <ng-container *ngIf="session.blocked; else sessionFree">

                            <mat-list-item> 
                                <small matLine>{{ session.timeAt }}</small>
                                <span matLine style="color: red">Intervalo bloqueado</span>
                                <button *ngIf="!session.candidate" mat-icon-button color="primary" matTooltip="Liberar esse intervalo"
                                    (click)="blockSession(false, i)">
                                    <mat-icon>settings_backup_restore</mat-icon>
                                </button>
                            </mat-list-item>

                        </ng-container>
     
                        <ng-template #sessionFree>
                           
                            <mat-list-item cdkDropList [cdkDropListData]="session" (cdkDropListDropped)="onSessionDropped($event, i)">

                                <img [src]="mediaEndpoint + session.candidate.avatar_profile" matListAvatar *ngIf="session.candidate?.avatar_profile" />
                                <mat-icon matListIcon *ngIf="session.candidate && session.candidate.avatar_profile == null" >account_circle</mat-icon>
                                <small matLine>{{ session.timeAt }} </small>
                                <span matLine *ngIf="!session.candidate">
                                    Sem candidato agendado
                                </span>
                                <p matLine *ngIf="session.candidate">
                                    {{ session.candidate.firstname }} {{ session.candidate.lastname }}
                                </p>

                                <span matLine *ngIf="session.candidate">
                                    
                                    <ng-container *ngIf="session.accept === null">
                                        <span style="color: brown">Esperando resposta do candidato</span>                                            
                                    </ng-container>

                                    <ng-container *ngIf="session.accept == 1">
                                        <span style="color: #09C">Candidato aceitou a entrevista</span>                                            
                                    </ng-container>

                                    <ng-container *ngIf="session.accept == 0">
                                        <span style="color: red">Candidato rejeitou a entrevista</span>
                                        
                                    </ng-container>
                                </span>

                                <ng-container *ngIf="!session.candidate">
                                    
                                    <button color="primary" mat-icon-button matTooltip="Adicionar candidato a partir desse horário"
                                        [disabled]="!hasSelection()"
                                        (click)="addCandidateInSession(i)">
                                        <mat-icon>person_add</mat-icon>
                                    </button>

                                    <button mat-icon-button color="accent" matTooltip="Bloquear esse intervalo"
                                        (click)="blockSession(true, i)">
                                        <mat-icon>block</mat-icon>
                                    </button>
                                </ng-container>

                                <ng-container *ngIf="session.candidate">
                                    <button color="accent" mat-icon-button matTooltip="Remover candidato" (click)="removeCandidate(i)">
                                        <mat-icon>person_remove</mat-icon>
                                    </button>
                                </ng-container>
                                <ng-container *ngIf="session?.candidate?.link_meet">
                                    <a [href]="session.candidate.link_meet" target="_blank" rel="noopener noreferrer" 
                                        (click)="checkDateAndConfirm($event, session.date, session.timeAt)">
                                        <button color="primary" mat-icon-button matTooltip="Abrir Link da Entrevista Online">
                                        <mat-icon>videocam</mat-icon>
                                        </button>
                                    </a>
                                </ng-container>


                            </mat-list-item> 
                        </ng-template>
                    </ng-container>                        
                </mat-list>
            </div>
        </ng-template>

        <mat-tab-group *ngIf="isSmallScreen$ | async; else desktopInterview" 
            #interviewTabs [selectedIndex]="selectedIndex">
            <mat-tab label="Entrevistas">
                <ng-container *ngTemplateOutlet="interviewContent"></ng-container>
            </mat-tab>
            <mat-tab label="Agendar horário">
                <ng-container *ngTemplateOutlet="sessionContent"></ng-container>    
            </mat-tab>
        </mat-tab-group>

        <ng-template #desktopInterview>
            <div class="sessions-wrapper">
            
                <ng-container *ngTemplateOutlet="interviewContent"></ng-container>
                <ng-container *ngTemplateOutlet="sessionContent"></ng-container>
                
            </div>
        </ng-template>       

    </ng-template>

    <mat-vertical-stepper [linear]="true" #stepper
        *ngIf="(isSmallScreen$ | async); else largeStepper">
        <mat-step label="Entrevistas" [completed]="selectedInterview !== null">
            <ng-container *ngTemplateOutlet="interviewStep"></ng-container>
        </mat-step>
        <mat-step label="Horários das entrevista">
            <ng-container *ngTemplateOutlet="sessionStep"></ng-container>
        </mat-step>
    </mat-vertical-stepper>

    <ng-template #largeStepper>
        <mat-horizontal-stepper [linear]="true" #stepper>
            <mat-step label="Entrevistas" [completed]="selectedInterview !== null">
                <ng-container *ngTemplateOutlet="interviewStep"></ng-container>
            </mat-step>
            <mat-step label="Horários das entrevista">
                <ng-container *ngTemplateOutlet="sessionStep"></ng-container>
            </mat-step>
        </mat-horizontal-stepper>
    </ng-template>   

</mat-dialog-content>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="submiting"></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting">
    <button color="accent" mat-dialog-close mat-button>Fechar</button>
    <button color="primary" mat-raised-button (click)="finish()" [disabled]="disableFinish">Concluir</button>
</mat-dialog-actions>